// gets the customer's browser preferences
export const browserLanguage: string = window.navigator.language
  ? window.navigator.language.substring(0, 2)
  : 'en';
